import React from 'react';

const ImageQuestion = ({ question: { file } }) => <>
    {file ? <img src={process.env.REACT_APP_API_URL + file.fileUrl} style={{ maxHeight: '250px' }} alt="" /> : null}
</>;

export default ImageQuestion;
